// eslint-disable-next-line import/prefer-default-export
export const SET_FOOTER_DATA = 'footer/SET_FOOTER_DATA';
